import clsx from 'clsx';
import React from 'react';
import SimpleBarReact from 'simplebar-react';
import { alpha, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden'
  },
  scroll: {
    maxHeight: '100%',
    '& .simplebar-scrollbar': {
      '&:before': {
        backgroundColor: alpha(theme.palette.grey[600], 0.48)
      },
      '&.simplebar-visible:before': {
        opacity: 1
      }
    },
    '& .simplebar-vertical': {
      width: 10
    },
    '& .simplebar-horizontal .simplebar-scrollbar': {
      height: 6
    },
    '& .simplebar-mask': {
      zIndex: 'inherit'
    },
    '& .simplebar-content-wrapper::-webkit-scrollbar': {
      display: 'none'
    }
  }
}));

export type ScrollbarsProps = {
  children?: React.ReactNode,
  className?: string,
};

function Scrollbars({ children, className }: ScrollbarsProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SimpleBarReact
        timeout={500}
        clickOnTrack={false}
        className={clsx(classes.scroll, className)}
      >
        {children}
      </SimpleBarReact>
    </div>
  );
}

export default Scrollbars;
